import React, { useEffect } from "react";
import TimeAgo from "react-timeago";
import { useNavigate } from "react-router-dom";
import { Button as BootstrapButton, Image } from "react-bootstrap";
import { useSelector, useDispatch } from "react-redux";
import { get } from "lodash";
import _ from "lodash";

import { useEngageContext } from "src/pages/engage/context/EngageContext";
import { fetchConversation } from "src/redux/actions/conversation";
import { Asset } from "src/types/assets";

import styles from "./liveViewSlider.module.scss";
import cx from "classnames";

const DEFAULT_ASSET_ICON = "/images/defaultIcons/default_asset.jpg";

export const LiveViewSlider = ({ show, onClose }: { show: boolean; onClose: () => void }) => {
  const { currentlyViewingAsset } = useEngageContext();

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const asset = currentlyViewingAsset ? (get(currentlyViewingAsset, "asset") as Record<string, unknown> | undefined) : undefined;
  const assetName = asset ? (get(asset, "name") as string) || "Asset" : null;
  const thumbnail = asset ? (get(asset, "icon.thumbnail") as string | undefined) ?? (get(asset, "icon.full") as string | undefined) : undefined;

  const conversation = useSelector((state: any) => _.get(state, `conversations.conversation.${currentlyViewingAsset?.share}.item`));

  useEffect(() => {
    if (currentlyViewingAsset?.share) {
      dispatch(fetchConversation(currentlyViewingAsset.share as string));
    }
  }, [currentlyViewingAsset, dispatch]);

  if (!show) return null;

  let conversationSource: string = conversation?.source as string;
  if (conversationSource == "Paperflite QuickSend") {
    conversationSource = "Quick Send";
  } else if (conversationSource == "Paperflite Link") {
    conversationSource = "Link";
  }

  const pageNumber = conversation?.pageNumber;
  const pages = get(conversation, "metadata.pages");

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <div className={styles.title}>Last viewed asset</div>
        <button type="button" className={styles.closeIcon} onClick={onClose} >
          <i className="paperflite-close" />
        </button>
      </div>

      <div className={styles.body}>
        {asset ? (
          <div className={styles.assetDetails}>
            <div className={styles.assetNameContainer}>
              <div className={styles.assetName}>{assetName}</div>
            </div>

            <div className={styles.shareDetails}>
                <div className={styles.shareDetail}>
                    <span className={styles.title}>shared</span>
                    <span className={styles.value}>{conversation?.totalAssetsCount} assets</span>
                </div>
                <div className={styles.shareDetail}>
                    <span className={styles.title}>time</span>
                    <span className={styles.value}>
                      <TimeAgo date={conversation?.createdDate} live={false} />
                    </span>
                </div>
                <div className={styles.shareDetail}>
                    <span className={styles.title}>via</span>
                    <span className={styles.value}>{conversationSource}</span>
                </div>
            </div>

            <div className={styles.assetThumbnail}>
              <Image
                src={thumbnail || DEFAULT_ASSET_ICON}
                alt=""
                className={styles.thumbnailImg}
                onError={(e) => {
                  (e.target as HTMLImageElement).src = DEFAULT_ASSET_ICON;
                }}
              />
            </div>

            {pageNumber && pages && (<div className={styles.assetExtraInfo}>
               <span>Observing page <span className={styles.pageNumber}>{pageNumber}</span> of <span className={styles.pages}>{pages}</span></span>
               <BootstrapButton className={styles.viewAssetLink} 
                onClick={() => {
                  navigate(`/assets/${(currentlyViewingAsset?.asset as Asset)?.id as string}`);
                  onClose();
                }}
              >
                <i className={cx(styles.viewAssetIcon, "paperflite-right-arrow")}></i>
              </BootstrapButton>
            </div>)}

          </div>
        ) : (
          <div className={styles.empty}>No asset viewing data for this recipient.</div>
        )}
      </div>
    </div>
  );
};